import React, { useEffect } from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { styled } from '@uhg-abyss/web/tools/styled';
import { useUser } from '@src/state/user';
import { FeedbackTab } from '@src/common/FeedbackTab';
import { registerAnalytics } from '@src/common/tools/analytics';
import { FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { Header } from './Header';
import { Footer } from './Footer';
import { Landing } from './Content/Landing';
import { W9Upload } from './Content/W9Upload';
import { TinRegistrationStatus } from './Content/TinRegistrationStatus';
import { SuperUser } from './Content/SuperUser';
import { MultiTinRegistrationStatus } from './Content/MultiTinRegistrationStatus';
import { PracticeInformation } from './Content/PracticeInformation';
import { TinReview } from './Content/TinReview';
import { Address } from './Content/Address';
import { Confirmation } from './Content/Confirmation';

const MainContainer = styled('div', {
  background: '$gray2',
  paddingBottom: 30,
  flex: '1 0 auto',
  minHeight: '85vh',
});

const Body = styled('div', {
  display: 'flex',
  minHeight: '100vh',
  fontFamily: '$primary',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

export const App = () => {
  const form = useForm();
  const { getUserInfo } = useUser.actions();
  const { uuid } = useUser.state();

  useEffect(() => {
    registerAnalytics();
    getUserInfo();
  }, []);

  const pageTitle = '{{title}} | Out of Network Portal';

  return !uuid ? null : (
    <Body>
      <FormProvider state={form}>
        <Header />
        <MainContainer>
          <Router.Routes title={pageTitle}>
            <Router.Route path="/" element={<Landing title="dashboard" />} />
            <Router.Route
              path="/tin-registration/step/1"
              element={<W9Upload title="Tin Registration" />}
            />
            <Router.Route
              path="/tin-registration/step/2"
              element={<PracticeInformation title="Tin Registration" />}
            />
            <Router.Route
              path="/tin-registration/step/3"
              element={<Address title="Tin Registration" />}
            />
            <Router.Route
              path="/tin-registration/step/4"
              element={<TinReview title="Tin Registration" />}
            />
            <Router.Route
              path="/tin-registration/confirmation"
              element={<Confirmation title="Tin Registration" />}
            />
            <Router.Route
              path="/superuser"
              element={<SuperUser title="Super User" />}
            />
            <Router.Route
              path="/multitin-registration-status"
              element={
                <MultiTinRegistrationStatus title="MultiTin Registration Status" />
              }
            />
            <Router.Route
              path="/tin-registration-status"
              element={
                <TinRegistrationStatus title="Tin Registration Status" />
              }
            />
          </Router.Routes>
          <FeedbackTab />
        </MainContainer>
        <Footer />
      </FormProvider>
    </Body>
  );
};
